import { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { setObj as Permison } from 'src/views/pages/modules/Set'

const useCheckPermison = (props) => {
    const { model, access, redirect = false } = props
    const redirectOrNavigate = useNavigate()
    const AccessLowerCase = access?.toLowerCase()?.trim()
    const state = useSelector((state) => state?.AdminUser)
    let { adminUser: AdminUser, users: modelSet } = state
    let Access
    if (AdminUser?.isDeveloper == 1) {
        Access = true
    } else {
        Access = modelSet?.[model?.trim()]?.includes(Number(Permison?.[AccessLowerCase]?.key))
        if (!Access) {
            Access = false
        }
    }
    useEffect(() => {
        if (!Access) {
            if (redirect) {
                redirectOrNavigate(-1)
                toast.error(`You don't have permission to ${AccessLowerCase} ${model}`)
            }
        }
    }, [])
    return Access
}

export default useCheckPermison
